const consulta_constante_de_alunos_novos = {
  path: "/consulta-constante-de-alunos-novos",
  redirect: "/consulta-constante-de-alunos-novos",
  meta: {
    breadCrumb: "Planejamento de Matrícula - Constantes Alunos Novos",
  },
  children: [
    {
      path: "/consulta-constante-de-alunos-novos",
      name: "consulta-constante-de-alunos-novos",
      component: () =>
        import(
          "@/views/ConsultaConstanteDeAlunosNovos/ConsultaConstanteDeAlunosNovos.vue"
        ),
    },
  ],
};

export { consulta_constante_de_alunos_novos };
